var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"page-footer","absolute":_vm.$vuetify.breakpoint.mdAndUp,"color":"transparent","height":"auto"}},[_c('links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }